import * as React from 'react';
import styled from 'styled-components';
import {mixinBtnMiddle, mixinResetBtnCss, mixinBtnCorporate, mixinWithBtnPropsFn, IBtnDefaultProps} from "./btn_mixin";

interface IProps
    extends IBtnDefaultProps, React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
}

const BtnCorporateMiddleDefault: React.FC<IProps> = (props) => {

    const { icon, widthSize, ...ButtonProps } = props;

    return (<button {...ButtonProps} />)

};

const BtnCorporateMiddle = styled(BtnCorporateMiddleDefault)`
    ${mixinResetBtnCss}
    ${mixinBtnMiddle}
    ${mixinBtnCorporate}
    
    ${props => mixinWithBtnPropsFn(props)}
`;

export default BtnCorporateMiddle;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/btn_corporate_middle.tsx